import React, { useEffect } from 'react';
import classnames from 'classnames';
// name,content
type Icon = [string,string];

export interface IconProps extends React.SVGProps<SVGSVGElement> {
  icon: Icon;
  darkMode?: boolean;
  className?: string;
  size?: string | number;
  color?: string;
}

const xmlns = 'http://www.w3.org/2000/svg';

let rootSVG: SVGSVGElement;
const getRootSVG = () => {
  if (rootSVG) {
    return rootSVG;
  }
  rootSVG = document.createElementNS(xmlns, 'svg');
  rootSVG.setAttribute('xmlns', xmlns);
  rootSVG.setAttribute('class', 'kid-root-svg');
  rootSVG.setAttribute(
    'style',
    'height:0px;visibility: hidden;position: absolute;left: -9999px;z-index: -9999'
  ); // 解决safari滚动底部白页
  rootSVG.setAttribute('aria-hidden', 'true');
  (document.body || document.documentElement).appendChild(rootSVG);
  return rootSVG;
};

const injectSymbol = (id: string, content: string) => {
  if (document.getElementById(id)) {
    return;
  }

  const root = getRootSVG();

  const el = document.createElementNS(xmlns, 'symbol');
  el.setAttribute('viewBox', '0 0 1024 1024');
  el.id = id;
  el.innerHTML = content;
  root.appendChild(el);
};

const useSymbol = (icon: Icon) => {
  const [key,content] = icon;
  const cls = `svg-${key}`;

  useEffect(() => {
    injectSymbol(cls, content);
  }, [icon]);

  return cls;
};

const iconStyle = (size?: string | number, color?: string, style?: any): any => {
  if (!size && !color) {
    return style;
  }

  const res = {} as any;

  if (size) {
    const s = typeof size === 'number' ? `${size}px` : size;
    res.width = s;
    res.height = s;
  }

  if (color) {
    res.color = color;
  }

  return Object.assign(res, style);
};

const BaseIcon = ({ icon, className, size, color, style, ...props }: IconProps) => {
  const id = useSymbol(icon);
  return (
    <svg
      xmlns={xmlns}
      className={classnames('svgfont', id, className)}
      aria-hidden={true}
      style={iconStyle(size, color, style)}
      viewBox='0,0,100,100'
      {...props}
    >
      <use xlinkHref={`#${id}`}></use>
    </svg>
  );
};

export default BaseIcon;
